import { render, staticRenderFns } from "./activity-cards-ranking.vue?vue&type=template&id=5f974ef2&scoped=true&"
import script from "./activity-cards-ranking.vue?vue&type=script&lang=js&"
export * from "./activity-cards-ranking.vue?vue&type=script&lang=js&"
import style0 from "./activity-cards-ranking.vue?vue&type=style&index=0&id=5f974ef2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f974ef2",
  null
  
)

export default component.exports